import { BaseInquiryClosingReasons } from 'base';

export const BaseCustomerInquiryCloseReasons = [
  { id: BaseInquiryClosingReasons.notNeeded, label: 'inquiry.closeInquiry.reason.notNeeded' },
  { id: BaseInquiryClosingReasons.solvedInternally, label: 'inquiry.closeInquiry.reason.solvedInternally' },
  { id: BaseInquiryClosingReasons.noApproval, label: 'inquiry.closeInquiry.reason.noApproval' },
  { id: BaseInquiryClosingReasons.other, label: 'inquiry.closeInquiry.reason.other' },
];
